import Link, { LinkProps } from "next/link";

interface Props {
    condition: boolean | (() => boolean);
    children: React.ReactNode;
}

export const If = ({ condition, children }: Props) => {
    const shouldRender =
        typeof condition === "function" ? condition() : condition;

    if (shouldRender) {
        return <>{children}</>;
    }
    return null;
};

interface ConditionalLinkProps
    extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href">,
        LinkProps {
    isLink?: boolean;
    children?: React.ReactNode;
}

export const ConditionalLink: React.FC<ConditionalLinkProps> = ({
    isLink = false,
    ...props
}) => {
    if (!isLink) return props.children;

    return <Link {...props} />;
};
